const Footer = () => {
    return (
        <div className="footer" style={{ 'textAlign': 'center', position: 'fixed' }}>
            <small>© 2024 Ricoh Co., Ltd.</small>
        </div>

    );
}

export default Footer;
